module.exports = "/_next/static/images/fallback_L-7a3cad9bd8f812ded8664298f5d8b4e7.png";